Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[typeof Symbol === 'function' ? Symbol.iterator : '@@iterator'](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((typeof Symbol === 'function' ? Symbol.iterator : '@@iterator') in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var filterComponents = ['NUMBERBOX', 'TAGCLOUD', 'TOGGLEBUTTON', 'DATEPICKER', 'DATERANGE', 'MULTIDATALIST', 'MULTIDROPDOWNLIST', 'MULTILIST', 'SINGLEDATALIST', 'SINGLEDROPDOWNLIST', 'SINGLELIST', 'DYNAMICRANGESLIDER', 'MULTIDROPDOWNRANGE', 'MULTIRANGE', 'RANGESLIDER', 'RATINGSFILTER', 'SINGLEDROPDOWNRANGE', 'SINGLERANGE'];
var rangeComponents = ['DATERANGE', 'DYNAMICRANGESLIDER', 'RANGESLIDER', 'RANGEINPUT', 'RATINGSFILTER'];
var rangeObjectComponents = ['SINGLERANGE', 'SINGLEDROPDOWNRANGE', 'MULTIRANGE', 'MULTIDROPDOWNRANGE'];

function parseRangeObject(filterKey, rangeObject) {
  return filterKey + '=' + rangeObject.start + '~' + rangeObject.end;
}

function parseFilterValue(componentId, componentValues) {
  var label = componentValues.label,
      value = componentValues.value,
      componentType = componentValues.componentType;
  var filterKey = label || componentId;

  if (rangeComponents.includes(componentType)) {
    return filterKey + '=' + value[0] + '~' + value[1];
  } else if (rangeObjectComponents.includes(componentType)) {
    if (Array.isArray(value)) {
      return value.map(function (item) {
        return parseRangeObject(filterKey, item);
      }).join();
    }

    return parseRangeObject(filterKey, value);
  } else if (Array.isArray(value)) {
    var isObject = typeof value[0] === 'object' && value[0] !== null;
    return isObject ? value.map(function (item) {
      return filterKey + '=' + item.value;
    }).join() : value.map(function (item) {
      return filterKey + '=' + item;
    }).join();
  }

  return filterKey + '=' + value;
}

function getFilterString(selectedValues) {
  if (selectedValues && Object.keys(selectedValues).length) {
    return Object.entries(selectedValues).filter(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          componentValues = _ref2[1];

      return filterComponents.includes(componentValues.componentType) && (componentValues.value && componentValues.value.length || componentValues.value.start || componentValues.value.end);
    }).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          componentId = _ref4[0],
          componentValues = _ref4[1];

      return parseFilterValue(componentId, componentValues);
    }).join();
  }

  return null;
}

exports.filterComponents = filterComponents;
exports.rangeComponents = rangeComponents;
exports.rangeObjectComponents = rangeObjectComponents;
exports.parseFilterValue = parseFilterValue;
exports.parseRangeObject = parseRangeObject;
exports.default = getFilterString;